// Start off by setting the webpack public path and nonce. This sets the location where all lazy assets will be loaded from
require('./context-parts/webpack.nonce.js');
require('./context-parts/webpack.public-path');

require('@nn/psdl-plugins/plugins.js');
require('./context-parts/context.modules');

require('./context-parts/context.nn-responsive.nn');
require('./context-parts/context.nn-responsive');
